export default __webpack_public_path__ + "static/media/904.3f633750.png";